import { render, staticRenderFns } from "./CRMCreateEditModal.vue?vue&type=template&id=038716f5"
import script from "./CRMCreateEditModal.vue?vue&type=script&lang=js"
export * from "./CRMCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports